'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isTransform = isTransform;
exports.noop = noop;
var transitions = {
  'WebkitTransition': 'webkitTransitionEnd',
  'MozTransition': 'transitionend',
  'OTransition': 'oTransitionEnd',
  'transition': 'transitionend'
};

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.canUseDOM = canUseDOM;
var canUseWorkers = typeof Worker !== 'undefined';
exports.canUseWorkers = canUseWorkers;
var canUseEventListeners = canUseDOM && !!(window.addEventListener || window.attachEvent);

exports.canUseEventListeners = canUseEventListeners;
var canUseViewport = canUseDOM && !!window.screen;
exports.canUseViewport = canUseViewport;
var isTouchDevice = canUseDOM && 'ontouchstart' in window;
exports.isTouchDevice = isTouchDevice;

function isTransform(name) {
  return name === 'transform' || name === '-webkit-transform' || name === '-moz-transform' || name === '-o-transform' || name === '-ms-transform';
}

function noop() {}

var slice = Array.prototype.slice;
exports.slice = slice;
var svgSupport = !!window.SVGElement;

exports.svgSupport = svgSupport;
var transitionEnd = null;
if (canUseDOM) {
  var div = document.createElement('div');
  for (var t in transitions) {
    if (div.style[t]) {
      exports.transitionEnd = transitionEnd = transitions[t];
    }
  }
}
exports.transitionEnd = transitionEnd;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/utils/index.js
 ** module id = 188
 ** module chunks = 0
 **/